import { Component, Injector, OnInit } from '@angular/core';
import { ConcilioComponent } from '@conciliome/concilio-core';
import { TunnelsQuery } from '@b2b-app/b2b-core';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'b2b-ui-download-confirmation',
  templateUrl: './b2b-download-confirmation.component.html',
  styleUrls: ['./b2b-download-confirmation.component.scss'],
})
export class B2bDownloadConfirmationComponent extends ConcilioComponent implements OnInit {
  tunnelsContent$ = this.tunnelsQuery.content$;
  pageSlug: string;
  rootPage: string;

  constructor(injector: Injector, private tunnelsQuery: TunnelsQuery) {
    super(injector);
    this.rootPage = this.routerService.url.split('/').filter((s) => s !== '')[0];
    this.addSubscription(
      this.route.params
        .pipe(
          tap((params) => {
            this.pageSlug = params['id'];
          })
        )
        .subscribe(() => {})
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
